import { blue, gold, gray, green, magenta, orange, purple, red, volcano } from '@ant-design/colors';
import dayjs from 'dayjs';
import { DATE_FORMAT } from '@/std/const/date';
import { unreachable } from '@/std/util';
import type { CobrancaBoletoStatus } from '../types/CobrancaBoletoStatus';

export function getCobrancaBoletoStatusTextAndColor(
    status: CobrancaBoletoStatus,
    vencimento: string | null,
): { text: string; color: string } {
    switch (status) {
        case 'Aguardando': {
            if (vencimento) {
                const now = dayjs();
                const vencimentoDate = dayjs(vencimento, DATE_FORMAT);

                if (vencimentoDate.isBefore(now, 'day')) {
                    return { color: volcano.primary ?? '', text: 'Vencida' };
                } else if (vencimentoDate.isSame(now, 'day')) {
                    return { color: gold.primary ?? '', text: 'Vencendo' };
                }
            }

            return { color: blue.primary ?? '', text: 'Aguardando' };
        }
        case 'Baixado': {
            return { color: magenta.primary ?? '', text: 'Baixado' };
        }
        case 'Devolvido Pix': {
            return { color: red.primary ?? '', text: 'Devolvido Pix' };
        }
        case 'Incorreto': {
            return { color: orange.primary ?? '', text: 'Incorreto' };
        }
        case 'Liquidado': {
            return { color: green.primary ?? '', text: 'Liquidado' };
        }
        case 'Liquidado Pix': {
            return { color: green[6] ?? '', text: 'Liquidado Pix' };
        }
        case 'Negativado': {
            return { color: volcano[7] ?? '', text: 'Negativado' };
        }
        case 'Protestado': {
            return { color: purple.primary ?? '', text: 'Protestado' };
        }
        case 'Total': {
            return { color: gray.primary ?? '', text: 'Total' };
        }

        default: {
            unreachable(status);
        }
    }
}
